/**
 * Formatação que o documento usa em mais de um lugar: a data do front matter e do registro, o hash
 * abreviado do rodapé e do bloco de anamnese. Sem dependência de fuso: o que chega já decidiu o seu.
 */

/** `2026-08-12` (ou qualquer ISO que comece assim) → `12/08/2026`; o resto sai como veio. */
export function formatIsoDate(iso: string) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  if (!m) return iso
  return `${m[3]}/${m[2]}/${m[1]}`
}

/** `a3f9c1e7…4b82d5`: os 8 primeiros e os 6 últimos caracteres; hash curto sai inteiro. */
export function abbreviateHash(hash: string) {
  return hash.length > 16 ? `${hash.slice(0, 8)}…${hash.slice(-6)}` : hash
}

/**
 * Um instante ISO 8601 como o documento o imprime: `12/08/2026 · 14:03 UTC`. O que não for ISO
 * com hora (uma data já formatada no fuso da clínica, por exemplo) sai como veio.
 */
export function formatInstant(value: string) {
  if (!/^\d{4}-\d{2}-\d{2}T/.test(value)) return value
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return value
  const hh = String(d.getUTCHours()).padStart(2, '0')
  const mm = String(d.getUTCMinutes()).padStart(2, '0')
  return `${formatIsoDate(d.toISOString())} · ${hh}:${mm} UTC`
}
